import requestAction from '../../utils/requestAction'
import ProductMeasurement from '../../models/ProductMeasurement';

export const upsertProductMeasurement = (productMeasurement: (ProductMeasurement)) =>
  requestAction('PRODUCTMEASUREMENT_UPSERT')(
    `productMeasurements${(productMeasurement as ProductMeasurement).id ? `/${(productMeasurement as ProductMeasurement).id}` : ''}`,
    (productMeasurement as ProductMeasurement).id ? 'PUT' : 'POST',
    productMeasurement
  )
